import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toast-icon" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "toast-content" }
const _hoisted_6 = { class: "toast-title" }
const _hoisted_7 = {
  key: 0,
  class: "toast-message"
}

import { ref, onMounted, onBeforeUnmount } from 'vue';


const __default__ = {
  name: 'ToastComponent'
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    message: {},
    duration: {},
    type: {},
    centered: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isVisible = ref(false);
const progress = ref(100);
let progressInterval: number;

onMounted(() => {
  isVisible.value = true;
  const duration = props.duration || 5000;
  const updateInterval = 10;
  const steps = duration / updateInterval;
  let currentStep = 0;

  progressInterval = setInterval(() => {
    currentStep++;
    progress.value = 100 - (currentStep / steps * 100);
    
    if (currentStep >= steps) {
      clearInterval(progressInterval);
      isVisible.value = false;
    }
  }, updateInterval);
});

onBeforeUnmount(() => {
  if (progressInterval) {
    clearInterval(progressInterval);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: "body",
    disabled: !_ctx.centered
  }, [
    (isVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["toast", [_ctx.type, { 'slide-in': isVisible.value, 'toast--centered': _ctx.centered }]])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.type === 'success')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "✅"))
              : (_ctx.type === 'error')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "❌"))
                : (_ctx.type === 'info')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "ℹ️"))
                  : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1),
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "progress-bar",
            style: _normalizeStyle({ width: progress.value + '%' })
          }, null, 4)
        ], 2))
      : _createCommentVNode("", true)
  ], 8, ["disabled"]))
}
}

})